import axios from "axios";
import { DEV } from "./constants";

// Checks whether any of the given waybills already have an active invoice,
// before an action that would generate one, so the caller can show the
// conflict and let the user decide instead of silently duplicating it.
// Fails "open" (returns no conflicts) on a network error - the backend's own
// defensive filter (see utils/common/invoiceGuard.js) still guarantees no
// duplicate invoice gets created even if this check couldn't run.
export const checkInvoiceConflicts = async (ids) => {
    if (!ids || ids.length === 0) return [];
    const token = localStorage.getItem("token");
    try {
        const response = await axios.post(
            `${DEV}/checkInvoiceConflicts`,
            { ids },
            { headers: { Authorization: `Bearer ${token}` } },
        );
        return response?.data?.data?.conflicts || [];
    } catch (error) {
        console.error("checkInvoiceConflicts failed:", error);
        return [];
    }
};
